import moment from 'moment'
import { defaultObj } from './state'
import isEmpty from '../../utility/isEmpty'

export default {
  setCustomerId (state, data) {
    state.customerId = data.customerId
  },

  setCustomerIds (state, data) {
    state.customerIds = data.customerIds
  },

  setMdmId (state, value) {
    if (!isEmpty(value)) {
      state.mdmId = value
    }
  },

  setCustomerData (state, data) {
    if (data.customerIds) {
      state.customerIds = data.customerIds
    }
    if (data.customerId) {
      state.customerId = data.customerId
    }
    if (data.customerName) {
      state.customerName = data.customerName
    }
    if (data.fullCustomerName) {
      state.fullCustomerName = data.fullCustomerName
    }
    if (data.customerFirstName) {
      state.customerFirstName = data.customerFirstName
    }
    if (data.customerLastName) {
      state.customerLastName = data.customerLastName
    }
    if (data.dob) {
      state.dob = data.dob
    }

    if (data.customerStoreId) {
      state.customerStoreId = data.customerStoreId
    }
    if (data.addresses) {
      state.addresses = data.addresses
    }
    if (data.phoneNumber) {
      state.phoneNumber = data.phoneNumber
    }
    if (data.email) {
      state.email = data.email
    }
    if (data.lastPayDate) {
      state.lastPayDate = moment(data.lastPayDate)
    }
    if (data.payFrequency) {
      state.payFrequency = data.payFrequency
    }
    if (data.discretionaryIncome !== undefined) {
      state.discretionaryIncome = data.discretionaryIncome
    }

    if (data.canUpdateUserLogin) {
      state.canUpdateUserLogin = data.canUpdateUserLogin
    }

    if (!isEmpty(data.hasVerifiedProfileEmail)) {
      state.hasVerifiedProfileEmail = data.hasVerifiedProfileEmail
    }

    if (!isEmpty(data.hasVerifiedProfilePhone)) {
      state.hasVerifiedProfilePhone = data.hasVerifiedProfilePhone
    }

    if (data.bank !== undefined) {
      state.bankAccountId = data.bank.id
      state.bankName = data.bank.bankName
      state.bankAccountNumber = data.bank.accountNumber
      state.bankRoutingNumber = data.bank.routingNumber
    }

    // Some people may not have these properties so we need to allow them to be set to undefined
    state.communicationSettings = data.communicationSettings
    state.displaySsn = data.displaySsn
  },

  setReferenceIds (state, referenceIds) {
    state.lmsReferenceIds = referenceIds
  },

  setReferralInfo (state, referralInfo) {
    state.referralInfo = referralInfo
  },

  setTempCommunicationSettings (state, data) {
    state.tempCommunicationSettings = data.tempCommunicationSettings
  },

  clearCustomerData (state) {
    state.customerId = ''
    state.customerIds = {}
    state.mdmId = ''
    state.customerName = ''
    state.fullCustomerName = ''
    state.customerFirstName = ''
    state.customerLastName = ''
    state.dob = moment()
    state.displaySsn = ''
    state.customerStoreId = ''
    state.addresses = []
    state.phoneNumber = ''
    state.email = ''
    state.status = 1
    state.lastPayDate = {}
    state.payFrequency = ''
    state.discretionaryIncome = 0
    state.bankName = ''
    state.bankAccountNumber = ''
    state.bankRoutingNumber = ''
    state.brands = []
    state.referralInfo = {}
    state.communicationSettings = {}
    state.canUpdateUserLogin = false

    if (this.cache.has('customer/getCustomerInfo') === true) {
      this.cache.delete('customer/getCustomerInfo')
    }

    if (this.cache.has('customer/getCoSignerCustomerInfo') === true) {
      this.cache.delete('customer/getCoSignerCustomerInfo')
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)

    if (this.cache.has('customer/getCustomerInfo') === true) {
      this.cache.delete('customer/getCustomerInfo')
    }

    if (this.cache.has('customer/getCoSignerCustomerInfo') === true) {
      this.cache.delete('customer/getCoSignerCustomerInfo')
    }
  }
}
